<template>
    <div>
      <loading :active.sync="loader.isLoading" :can-cancel="loader.canCancel" :is-full-page="loader.fullPage" :color="loader.color" :height="loader.height" :width="loader.width" :background-color="loader.backgroundColor" :loader="loader.loader"></loading>
      <div class="row">
          <div class="col-md-12">
            <div class="top-list-toolbar">
              <h4 class="text-primary">Kas Besar</h4>
              <ol class="breadcrumb breadcrumb-card-header">
                <li class="breadcrumb-item">
                  <a href="javascript:void(0);" @click="backParent">Kas Besar</a>
                </li>
                <li class="breadcrumb-item active">
                  <span v-if="cash.id === null">New</span>
                  <span v-else>{{ cash.cash_no }}</span>
                </li>
              </ol>
              <div>
                <button class="btn btn-success btn-sm pull-left dropdown-toggle" type="button" id="action" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" v-show="cash.cash_no !== null">Action</button>
                <div class="dropdown-menu" aria-labelledby="action">
                  <a class="dropdown-item" href="javascript:void(0)" data-toggle="modal" data-target="#modalRequestEdit" data-backdrop="static" data-keyboard="false">Request Edit</a>
                  <a class="dropdown-item" href="javascript:void(0)" @click="setAllJournal('reply')">Set Journal</a>
                  <a class="dropdown-item" href="javascript:void(0)" @click="validate">Validate</a>
                  <a class="dropdown-item" href="javascript:void(0)" @click="unlock" v-if="authUser.permissions.finance_cash_unlock">Unlock</a>
                  <a class="dropdown-item" href="javascript:void(0)" @click="deleteCash" v-if="authUser.permissions.finance_cash_unlock">Delete</a>
                </div>
                <button type="button" @click="saveCash" class="btn btn-sm btn-soft-primary pull-left" v-if="cash.id === null">Save</button>
                <button type="button" @click="updateCash('reply')" class="btn btn-sm btn-soft-primary pull-left" v-else>Update</button>
                <button type="button" @click="approveCash" class="btn btn-sm btn-hard-primary pull-left" v-if="cash.id !== null"><i class="fa fa-check"></i> Approve</button>
              </div>
            </div>
          </div>
      </div>

      <div class="card card-list">
        <div class="card-header">
          <h5>Kas Besar</h5>
        </div>
        <div class="card-body">
          <div class="alert alert-danger alert-dismissible fade show" role="alert" v-if="alert.length > 0">
            <ul v-for="(a, index) in alert" :key="index">
              <li v-html="a"></li>
            </ul>
          </div>
          <div class="row">
            <div class="col-md-4">
              <dl class="dl-custom row">
                <dt class="col-md-4">Date</dt>
                <dd class="col-md-8">
                  <datetime v-model="cash.cash_date" format="dd/MM/yyyy" class="form-control" value-zone="local" zone="local" v-if="authUser.permissions.sale_backdate"></datetime>
                  <datetime v-model="cash.cash_date" format="dd/MM/yyyy" class="form-control" value-zone="Asia/Jakarta" zone="Asia/Jakarta" v-else :disabled="cash.id !== null" @input="checkDate"></datetime>
                </dd>

                <dt class="col-md-4">Company</dt>
                <dd class="col-md-8">
                  <select v-model="cash.company_no" class="form-control" :disabled="cash.lock" @change="setCompany">
                    <option v-for="c in companyList" :key="c.id" :value="c.company_no">{{ c.name }}</option>
                  </select>
                </dd>

                <dt class="col-md-4">Type</dt>
                <dd class="col-md-8">
                  <select v-model="cash.type_id" class="form-control">
                    <option v-for="t in typeList" :key="t.id" :value="t.id">{{ t.name }}</option>
                  </select>
                </dd>

                <dt class="col-md-4">Notes</dt>
                <dd class="col-md-8"><textarea v-model="cash.notes" class="form-control" rows="3" :disabled="cash.lock"/></dd>
              </dl>
            </div>
          </div>
          <hr>
          <div class="row">
            <div class="col-md-12">
              <ul class="nav nav-tabs nav-bordered">
                <li class="nav-item">
                  <a href="#data" data-toggle="tab" aria-expanded="false" class="nav-link active">
                    Data
                  </a>
                </li>
                <li class="nav-item">
                  <a href="#journal" data-toggle="tab" aria-expanded="true" class="nav-link">
                    Journal
                  </a>
                </li>
              </ul>
              <div class="tab-content">
                <div class="tab-pane active" id="data">
                  <div class="table-responsive">
                    <table class="table table-sm table-item table-hover">
                      <thead>
                        <th>Report</th>
                        <th style="width: 10%">Type</th>
                        <th style="width: 10%">Method</th>
                        <th style="width: 30%">Account</th>
                        <th style="width: 25%">Description</th>
                        <th style="width: 10%">Total</th>
                        <th>Journal</th>
                        <th>#</th>
                      </thead>
                      <tbody>
                          <tr v-for="(d, index) in detailList" :key="index" >
                            <td>
                              <span v-if="d.report_no !== null"><i class="fa fa-check" style="color: green"></i></span>
                            </td>
                            <td>
                              <select class="form-control" v-model="d.type" :disabled="cash.lock">
                                <option value="outcome">Outcome</option>
                                <option value="income">Income</option>
                              </select>
                            </td>
                            <td>
                                <select class="form-control" v-model="d.method_id" disabled="disabled">
                                  <option v-for="p in paymentMethodList" :key="p.id" :value="p.id">{{ p.name }}</option>
                                </select>
                            </td>
                            <td>
                              <v-select :options="accountSelect" :reduce="account => account.meta.code" label="account" v-model="d.account_code" :disabled="cash.lock"/>
                              <!-- <pre>{{ accountSelect }}</pre> -->
                            </td>
                            <td><textarea v-model="d.description" @input="d.description=$event.target.value.toUpperCase()" cols="5" class="form-control" :disabled="cash.lock"/></td>
                            <td class="text-right"><input type="text" v-model="d.amount" class="form-control form-control-right" v-money="money" @keyup="calcRow(index)" :disable="cash.lock"/></td>
                            <td>{{ d.total_journal | currency }}</td>
                            <td>
                              <button type="button" class="btn btn-sm btn-danger" @click="removeDetail(index)" :disabled="cash.lock"><i class="fa fa-trash" aria-hidden="true"></i></button>
                              <button type="button" class="btn btn-sm btn-hard-primary" @click="setJournal(d.id)" :disabled="cash.lock"><i class="fa fa-share"></i></button>
                            </td>
                          </tr>
                          <tr>
                              <td colspan="8">
                                <span @click="addLine" class="link-secondary" v-if="cash.lock === false">
                                  <i class="fa fa-plus"></i> Add Kas
                                </span>
                              </td>
                          </tr>
                          <tr>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td class="text-right font-14"><b>Total Income</b></td>
                            <td class="text-right font-14"><b>{{ totalIncomeDetail | currency }}</b></td>
                            <td></td>
                            <td></td>
                          </tr>
                          <tr>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td class="text-right font-14"><b>Total Outcome</b></td>
                            <td class="text-right font-14"><b>{{ totalOutcomeDetail | currency }}</b></td>
                            <td></td>
                            <td></td>
                          </tr>
                          <tr>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td class="text-right font-14"><b>Total</b></td>
                            <td class="text-right font-14"><b>{{ cash.total | currency }}</b></td>
                            <td></td>
                            <td></td>
                          </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div class="tab-pane" id="journal">
                  <table class="table table-sm table-item table-hover table-striped">
                    <thead>
                      <th>Journal Code</th>
                      <th>Date</th>
                      <th>Account Code</th>
                      <th>Description</th>
                      <th class="text-right">Debit</th>
                      <th class="text-right">Credit</th>
                    </thead>
                    <tbody>
                      <tr v-for="j in cash.journals" :key="j.id">
                        <td>
                          <span v-if="j.hierarchy === 1">
                            {{ j.journal_code }} - <b>{{ j.description }}</b>
                            <span class="badge badge-success ml-1" v-if="j.status === 'posted'">{{ j.status }}</span>
                            <span class="badge badge-warning ml-1" v-else>{{ j.status }}</span>
                          </span>
                          <span v-else></span>
                        </td>
                        <td>
                          <span v-if="j.hierarchy === 1">{{ j.journal_date | dateFormat('DD/MM/YYYY') }}</span>
                          <span v-else-if="j.hierarchy === 2"></span>
                          <span v-else></span>
                        </td>
                        <td>
                          <span v-if="j.hierarchy === 1"></span>
                          <span v-else-if="j.hierarchy === 2"><b>{{ j.account_code }}</b> {{ j.account }}</span>
                          <span v-else></span>
                        </td>
                        <td>
                          <span v-if="j.hierarchy === 1"></span>
                          <span v-else-if="j.hierarchy ===2">{{ j.description }}</span>
                          <span v-else></span>
                        </td>
                        <td class="text-right">
                          <span v-if="j.hierarchy === 1"></span>
                          <span v-else-if="j.hierarchy === 2">{{ j.debit | currency }}</span>
                          <span v-else><b>{{ j.debit | currency }}</b></span>
                        </td>
                        <td class="text-right">
                          <span v-if="j.hierarchy === 1"></span>
                          <span v-else-if="j.hierarchy === 2">{{ j.credit | currency }}</span>
                          <span v-else><b>{{ j.credit | currency }}</b></span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <button class="btn btn-sm btn-hard-primary pull-right" @click="postingJournal"><i class="fa fa-plane"></i> Posting</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row justify-content-md-center">
        <div class="col-md-6">
          <h5>Logs:</h5>
          <div class="alert alert-info" role="alert" v-for="l in cash.logs" :key="l.id">
            <b>{{ l.user }}</b> - {{ l.log_date | dateFormat('DD/MM/YYYY HH:mm:ss') }} <span>"{{ l.description }}"</span>
          </div>
        </div>
      </div>
      <SalesRequestModal @getRequestEdit="requestEdit"/>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import { lockUrl, cohUrl, getHeader, journalUrl } from '@/config'
import axios from 'axios'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import SalesRequestModal from '@/components/sales/SalesRequestModal.vue'

export default {
  name: 'KasBesarForm',
  props: ['cash'],
  components: {
    Loading,
    SalesRequestModal
  },
  data () {
    return {
      alert: [],
      dataCash: {},
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 0,
        masked: true /* doesn't work with directive */
      },
      loader: {
        isLoading: false,
        fullPage: true,
        color: '#007bff',
        canCancel: false,
        height: 128,
        width: 128,
        backgroundColor: '#ffffff',
        loader: 'spinner'
      }
    }
  },
  computed: {
    ...mapState({
      paymentMethodList: state => state.paymentMethods.paymentMethodList,
      bankList: state => state.banks.bankList,
      authUser: state => state.users.authUser,
      accountList: state => state.accounts.accountList,
      taxList: state => state.taxes.taxList,
      companyList: state => state.companies.companyList,
      typeList: state => state.cohs.typeList
    }),
    totalOutcomeDetail () {
      var sum = 0
      var array = this.cash.details.filter(d => d.type === 'outcome')
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].total)
      }
      return sum
    },
    totalIncomeDetail () {
      var sum = 0
      var array = this.cash.details.filter(d => d.type === 'income')
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].total)
      }
      return sum
    },
    totalDetail () {
      var sum = 0
      var array = this.cash.details
      for (let i = 0; i < array.length; i++) {
        var outcome = array[i].type === 'outcome' ? array[i].total : 0
        var income = array[i].type === 'income' ? array[i].total : 0
        if (income === 0) {
          sum += parseFloat(outcome)
        } else {
          sum += parseFloat(income) - parseFloat(outcome)
        }
      }
      return sum
    },
    accountSelect: function () {
      var loop = []
      var array = this.accountList.filter(d => d.company_no === this.cash.company_no)
      for (var x = 0; x < array.length; x++) {
        var obj = {
          account: array[x].account_code + ' - ' + array[x].account_name,
          meta: {
            code: array[x].account_code
          }
        }
        loop.push(obj)
      }
      return loop
    },
    detailList: function () {
      return this.cash.details
    }
  },
  methods: {
    async deleteCash () {
      await axios.delete(cohUrl + '/' + this.cash.id, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          this.$swal('Success', response.data.message, 'success')
          this.$emit('backClicked')
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
    },
    async unlock () {
      await axios.post(cohUrl + '/unlock', this.cash, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          this.$swal('Lock', 'Cash On Hand unlock', 'success')
          this.$emit('backClicked')
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
    },
    async requestEdit (value) {
      var obj = {
        request_by: this.authUser.username,
        lock_no: this.cash.cash_no,
        lock_note: value,
        type: 'coh'
      }
      console.log(obj)
      await axios.post(lockUrl, obj, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          this.$swal('Lock', 'Cash On Hand has been requested', 'success')
          this.$emit('backClicked')
        })
        .catch(error => {
          console.log(error)
          console.log(error.response.data.message)
          this.$swal('Cash On Hand', error.response.data.message, 'error')
          throw error
        })
    },
    async validate () {
      this.alert = []
      if (parseFloat(this.totalIncomeDetail) === 0 && parseFloat(this.totalOutcomeDetail) === 0) {
        this.alert.push('<b>Total Outcome & Income</b> masih 0')
      }
      var array = this.cash.details
      var row = 0
      for (let i = 0; i < array.length; i++) {
        row += 1
        if (array[i].account_code === null) {
          this.alert.push('<b>Account No</b> harus diinput terlebih dahulu (Row:' + row + ')')
        }
        if (array[i].amount === null || parseFloat(array[i].total) === 0) {
          this.alert.push('<b>Total Account</b> harus diinput terlebih dahulu (Row:' + row + ')')
        }
        var desc = array[i].description.trim()
        if (desc === null || desc === ' ' || desc === '') {
          this.alert.push('<b>Description</b> harus diinput terlebih dahulu (Row:' + row + ')')
        }
      }
    },
    async checkDate () {
      var date1 = new Date()
      date1.setHours(0, 0, 0, 0)
      var date2 = new Date(this.cash.cash_date)
      date2.setHours(0, 0, 0, 0)
      var remaining = date2.getTime() - date1.getTime()
      var diffInDay = (Math.round(remaining / (1000 * 3600 * 24)))
      console.log('Diff in a day ' + diffInDay)
      if (diffInDay > 0) {
        this.$swal('Error', 'Tanggal tidak boleh lebih dari hari ini (' + diffInDay + ' hari)', 'error')
        this.cash.cash_date = new Date().toISOString()
      } else if (Math.abs(diffInDay) > 2) {
        this.$swal('Error', 'Tanggal tidak boleh kurang dari 2 hari', 'error')
        this.cash.cash_date = new Date().toISOString()
      }
    },
    async setCompany () {
      const cmp = this.companyList.find(d => d.company_no === this.cash.company_no)
      var strid = null
      if (cmp.company_no === 'C0001') {
        strid = 'kas-besar-asp'
      } else {
        strid = 'kas-besar-psa'
      }
      const typeID = this.typeList.find(d => d.id === strid)
      this.cash.type_id = typeID.id
    },
    async approveCash () {
      await this.validate()
      if (this.alert.length > 0) {
        await window.scrollTo(0, 0)
        await this.$swal('Validation', 'Data Kas Belum valid, cek inputan terlebih dahulu', 'error')
        return false
      }
      await this.updateCash('noreply')
      await axios.post(cohUrl + '/approve', { id: this.cash.id }, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          console.log(response.data.message)
        })
        .catch(error => {
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
        })
      await this.setAllJournal('no reply')
      await this.backParent()
    },
    async postingJournal () {
      var array = this.cash.journals.filter(d => d.hierarchy === 1)
      for (let i = 0; i < array.length; i++) {
        var message = ''
        await axios.post(journalUrl + '/posting', { id: array[i].id }, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
          .then(response => {
            message = response.data.message
          })
          .catch(error => {
            console.log(error.response)
            message = error.response.data.message
          })
      }
      await this.$swal('Success', message, 'success')
      await this.backParent()
    },
    async setAllJournal (reply) {
      var array = this.cash.details
      var resp = {
        error: false,
        message: null
      }
      for (let i = 0; i < array.length; i++) {
        if (typeof array[i].id !== 'undefined') {
          await axios.post(cohUrl + '/journal-detail/', { id: array[i].id }, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
            .then(response => {
              console.log(response.data.message)
              resp.error = false
              resp.message = response.data.message
            })
            .catch(error => {
              console.log(error.response)
              this.$swal('Error', error.response.data.message, 'error')
              throw error
            })
        }
      }
      if (reply === 'reply') {
        if (resp.error === false) {
          await this.$swal('Success', resp.message, 'success')
          await this.backParent()
        }
      }
    },
    setJournal (id) {
      axios.post(cohUrl + '/journal-detail/', { id: id }, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          this.$swal('Journal', response.data.message, 'success')
        })
        .catch(error => {
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
        })
    },
    calcRow (index) {
      var detail = this.cash.details[index]
      var amount = parseFloat(detail.amount.replace(/\./g, ''))
      detail.total = amount
      if (this.totalIncomeDetail === 0) {
        this.cash.total = this.totalOutcomeDetail
      } else {
        this.cash.total = this.totalIncomeDetail - this.totalOutcomeDetail
      }
    },
    toJournal: function (id) {
      var url = '/finance/general-journal?id=' + id
      window.open(url, '_blank')
    },
    removeDetail: function (index) {
      var detail = this.detailList[index]
      if (typeof detail.id !== 'undefined') {
        this.$swal.fire({
          title: 'Are you sure Delete this?',
          text: "You won't be able to revert this",
          icon: 'error',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!!'
        }).then((result) => {
          if (result.value) {
            axios.delete(cohUrl + '/detail/' + detail.id, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
              .then(response => {
                console.log(response.data.data)
                this.$swal(
                  'Successfully',
                  response.data.message,
                  'success'
                )
                this.detailList.splice(index, 1)
              })
              .catch(error => {
                console.log(error.response)
              })
          }
        })
      } else {
        this.detailList.splice(index, 1)
      }
    },
    saveJournal: function () {
      var data = {
        id: this.cash.id
      }
      axios.post(cohUrl + '/journal-process/', data, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          this.$emit('backClicked')
          console.log(response.data.data)
        })
        .catch(error => {
          console.log(error.response)
          this.$swal(
            'Error',
            error.response.data.message,
            'error'
          )
        })
    },
    async saveCash () {
      await this.validate()
      if (this.alert.length > 0) {
        await window.scrollTo(0, 0)
        await this.$swal('Validation', 'Data Kas Belum valid, cek inputan terlebih dahulu', 'error')
        return false
      }
      await this.$Progress.start()
      this.loader.isLoading = true
      this.dataCash = {
        id: null,
        cash_no: null,
        cash_date: this.cash.cash_date,
        branch_no: this.cash.branch_no,
        company_no: this.cash.company_no,
        status: 'open',
        lock: false,
        username: this.cash.username,
        type: this.cash.type,
        type_id: this.cash.type_id,
        total: this.cash.total,
        memo_no: this.cash.memo_no,
        notes: this.cash.notes,
        employee_no: this.cash.employee_no,
        outstanding: this.cash.outstanding,
        outstanding_date: this.cash.outstanding_date
      }
      var dataError = {
        error: false,
        message: ''
      }
      var dataCash = {}
      await axios.post(cohUrl, this.dataCash, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          dataError = {
            error: false,
            message: response.data.message
          }
          dataCash = response.data.data
        })
        .catch(error => {
          console.log(error.response)
          this.$Progress.finish()
          this.loader.isLoading = false
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
      var array = this.cash.details
      var cdetail = []
      for (let i = 0; i < array.length; i++) {
        var obj = {
          cash_no: dataCash.cash_no,
          cash_date: dataCash.cash_date,
          branch_no: dataCash.branch_no,
          company_no: dataCash.company_no,
          method_id: array[i].method_id,
          type: array[i].type,
          bank_id: array[i].bank_id,
          tax_id: array[i].tax_id,
          tax: array[i].tax,
          amount: parseFloat(array[i].amount.replace(/\./g, '')),
          total: array[i].total,
          description: array[i].description,
          memo_no: array[i].memo_no,
          account_code: array[i].account_code
        }
        await axios.post(cohUrl + '/detail', obj, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
          .then(response => {
            console.log(response.data.message)
            cdetail.push(response.data.data)
          })
          .catch(error => {
            console.log(error.response)
            this.$swal('Error', error.response.data.message, 'error')
            return false
          })
      }
      for (let i = 0; i < cdetail.length; i++) {
        await axios.post(cohUrl + '/journal-detail/', { id: cdetail[i].id }, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
          .then(response => {
            console.log(response.data.message)
          })
          .catch(error => {
            console.log(error)
            console.log(error.response)
          })
      }
      await this.$Progress.finish()
      this.loader.isLoading = false
      this.alert = []
      if (dataError.error === true) {
        await this.$swal('Error', dataError.message, 'error')
      } else {
        await this.$swal('Success', dataError.message, 'success')
      }
      await this.backParent()
    },
    async updateCash (noreply) {
      await this.validate()
      if (this.alert.length > 0) {
        await window.scrollTo(0, 0)
        await this.$swal('Validation', 'Data Kas Belum valid, cek inputan terlebih dahulu', 'error')
        return false
      }
      await this.$Progress.start()
      this.loader.isLoading = true
      this.dataCash = {
        id: this.cash.id,
        cash_no: this.cash.cash_no,
        cash_date: this.cash.cash_date,
        branch_no: this.cash.branch_no,
        company_no: this.cash.company_no,
        status: 'open',
        lock: false,
        username: this.cash.username,
        type: this.cash.type,
        type_id: this.cash.type_id,
        total: this.cash.total,
        memo_no: this.cash.memo_no,
        notes: this.cash.notes,
        employee_no: this.cash.employee_no,
        outstanding: this.cash.outstanding,
        outstanding_date: this.cash.outstanding_date
      }
      var dataError = {
        error: false,
        message: ''
      }
      var dataCash = {}
      await axios.put(cohUrl + '/' + this.cash.id, this.dataCash, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          dataError = {
            error: false,
            message: response.data.message
          }
          dataCash = response.data.data
        })
        .catch(error => {
          console.log(error.response)
          dataError = {
            error: true,
            message: error.response.data.message
          }
          this.$Progress.finish()
          this.loader.isLoading = false
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
      var array = this.cash.details
      var cdetail = []
      for (let i = 0; i < array.length; i++) {
        var obj = {}
        if (typeof array[i].id === 'undefined') {
          obj = {
            cash_no: dataCash.cash_no,
            cash_date: dataCash.cash_date,
            branch_no: dataCash.branch_no,
            company_no: dataCash.company_no,
            method_id: array[i].method_id,
            type: array[i].type,
            bank_id: array[i].bank_id,
            tax_id: array[i].tax_id,
            tax: array[i].tax,
            amount: parseFloat(array[i].amount.replace(/\./g, '')),
            total: array[i].total,
            description: array[i].description,
            memo_no: array[i].memo_no,
            account_code: array[i].account_code
          }
        } else {
          obj = {
            id: array[i].id,
            cash_no: dataCash.cash_no,
            cash_date: dataCash.cash_date,
            branch_no: dataCash.branch_no,
            company_no: dataCash.company_no,
            method_id: array[i].method_id,
            type: array[i].type,
            bank_id: array[i].bank_id,
            tax_id: array[i].tax_id,
            tax: array[i].tax,
            amount: parseFloat(array[i].amount.replace(/\./g, '')),
            total: array[i].total,
            description: array[i].description,
            memo_no: array[i].memo_no,
            account_code: array[i].account_code
          }
        }
        await axios.post(cohUrl + '/detail', obj, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
          .then(response => {
            console.log(response.data.message)
            cdetail.push(response.data.data)
          })
          .catch(error => {
            console.log(error.response)
            this.$swal('Error', error.response.data.message, 'error')
          })
      }
      for (let i = 0; i < cdetail.length; i++) {
        await axios.post(cohUrl + '/journal-detail/', { id: cdetail[i].id }, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
          .then(response => {
            console.log(response.data.message)
          })
          .catch(error => {
            console.log(error)
            console.log(error.response)
          })
      }
      if (noreply === 'reply') {
        if (dataError.error) {
        } else {
          await this.$Progress.finish()
          this.loader.isLoading = false
          this.alert = []
          await this.$swal('Success', dataError.message, 'success')
          await this.backParent()
        }
      }
    },
    backParent: function () {
      this.alert = []
      this.$emit('backClicked')
    },
    addLine: function () {
      var obj = {
        cash_no: this.cash.cash_no,
        cash_date: this.cash.cash_date,
        branch_no: this.cash.branch_no,
        company_no: this.cash.company_no,
        method_id: 1,
        bank_id: null,
        tax_id: null,
        tax: 0,
        amount: '0',
        total: '0',
        description: '',
        memo_no: null,
        type: 'outcome',
        total_journal: '0'
      }
      this.cash.details.push(obj)
    }
  }
}
</script>
